import Swiper from "swiper/dist/js/swiper.min.js";
import sub from "../common/sub";
import axios from "axios";
import queryString from "query-string";
import FormPreloaderInstance from "./form-preloader";
import isEmail from 'validator/lib/isEmail';
import WindowStore from "../store/windowStore";

export default class {
    constructor() {
        this.footerLogoSlider = document.querySelector('.soutine-properties__logos');
        this.newsletterBtn = new sub('.newsletter__submit');
        this.formPreloader = new FormPreloaderInstance('.newsletter-popup__preloader');
        this.successPopup = new sub('.newsletter-popup__success');
        this.newsletterPopup = new sub('.newsletter-popup');
        this.errorNotification = new sub('.newsletter-popup__error-notification');
        this.successPopup.hide();
        this.newsletterPopup.hide();
        this.userEmail = '';
        this.userName = '';
        this.userSecondName = '';
        this.hashName = '#newsletter';
    }

    addIconSlider() {
        this.textSlider = new Swiper(this.footerLogoSlider, {
            speed: 900,
            spaceBetween: 50,
            loop: true,
            autoplay: true,
            pagination: {
                el: '.soutine-properties__pagination',
                type: 'bullets'
            },
        });
    }

    toggleValidation(elem, isValid) {
        if(isValid) {
            elem.classList.remove('invalid');
        } else {
            elem.classList.add('invalid');
        }
    }

    validateTextField(el) {
        this.toggleValidation(el.parentNode.querySelector('.form__notification'), el.value)
    }

    validateEmailField(el) {
        this.toggleValidation(el.parentNode.querySelector('.form__notification'), isEmail(el.value))
    }

    validateForm() {
        this.validateTextField(this.newsletterPopup.refs.name);
        this.validateTextField(this.newsletterPopup.refs.lastName);
        this.validateEmailField(this.newsletterPopup.refs.email);
    }

    getFormData() {
        this.userEmail = this.newsletterPopup.refs.email.value;
        this.userName = this.newsletterPopup.refs.name.value;
        this.userSecondName = this.newsletterPopup.refs.lastName.value;
        this.dateOfBirth = this.newsletterPopup.refs.dateOfBirth.value;

        return {
            email: this.newsletterPopup.refs.email.value,
            first_name: this.newsletterPopup.refs.name.value,
            last_name: this.newsletterPopup.refs.lastName.value,
            dateOfBirth: this.newsletterPopup.refs.dateOfBirth.value,
        }
    }

    doesFormValid() {
      return isEmail(this.userEmail) && this.userName && this.userSecondName
    }

    showSuccessPopup() {
        this.successPopup.show()
    }

    async subscribeForNewsletter(data) {
        return axios({
            method: 'post',
            url: '/api/?subscription',
            data: queryString.stringify(data),
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        })
    }

    addEventListenrForFooterBtn() {
        this.newsletterBtn.el.addEventListener('click', (e) => {
            e.stopPropagation()
            this.openNewsLetterPopup();
        })
    }

    openNewsLetterPopup() {
        this.errorNotification.hide();
        this.newsletterPopup.show();
        history.replaceState(null, null, this.hashName);
    }

    fitSuccessPopupToScreenSize() {
        if(WindowStore.isLargeMobile()) {
            this.newsletterPopup.el.querySelector('.newsletter-popup__bordered').style.height = '100%'
            this.newsletterPopup.el.querySelector('.newsletter-popup__bordered').style.overflow = 'hidden'
            this.newsletterPopup.refs.card.style.height = '100%'
        }
    }

    removeStylesForSuccesPopup() {
        this.newsletterPopup.el.querySelector('.newsletter-popup__bordered').style.height = 'auto'
        this.newsletterPopup.el.querySelector('.newsletter-popup__bordered').style.overflow = 'visible'
        this.newsletterPopup.refs.card.style.height = 'auto'
    }

    submitNewsletterPopupListener() {
        this.newsletterPopup.refs.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            this.validateForm();
            const formData = this.getFormData();
            console.log(formData);

            if(!this.doesFormValid()) return

            try {
                this.formPreloader.show();
                const result = await this.subscribeForNewsletter(formData);
                this.formPreloader.hide();

                if(result.status !== 200) throw new Error();

                this.fitSuccessPopupToScreenSize()
                this.showSuccessPopup();
                this.newsletterPopup.refs.form.reset();
            } catch (e) {
                this.errorNotification.show()
            }
        })

        this.newsletterPopup.refs.close.addEventListener('click', () => {
            this.closeNewsletterPopup();
        })
    }

    closeNewsletterPopup() {
        this.newsletterPopup.hide();
        this.successPopup.hide();
        history.replaceState(null, null, ' ')
        this.removeStylesForSuccesPopup();
    }

    init() {
        console.log(window.hash)
        if(window.location.hash === this.hashName) this.openNewsLetterPopup();
        this.addIconSlider();
        this.addEventListenrForFooterBtn();
        this.submitNewsletterPopupListener();
        this.newsletterPopup.el.addEventListener('click', (e) => {
            if(e.target === this.newsletterPopup.el) this.closeNewsletterPopup()
        })
        // clickOutside(this.newsletterPopup.refs.card, .bind(this))
    }
}
